import React from "react";

export default function FlightFilter({
  stops = [],
  airlines = [],
  airlinesName = [],
  checkedStop = [],
  setCheckedStop,
  checkedAirline = [],
  setCheckedAirline,
  selectedFlights = [],
  passengers = {},
  showReturnFlights = false,
  onChangeDeparture = null,
  isRoundtrip = false,
  searchInfo = null,
}) {
  const handleStopChange = (e) => {
    const value = e.target.value;
    setCheckedStop((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const handleAirlineChange = (e) => {
    const value = e.target.value;
    setCheckedAirline((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const getName = (ma) => {
    const airline = airlinesName.find((item) => item.ma === ma);
    if (airline) {
      return airline.ten + " (" + airline.ma + ")";
    }
    return ma;
  };

  return (
    <div className="left_side_search_area mt-3">
      {/* Chỉ hiển thị thông tin chuyến bay khi đã có chuyến được chọn */}
      {selectedFlights && selectedFlights.length > 0 && (
        <div className="left_side_search_boxed">
          <div className="tour_details_right_box_heading mb-3">
            <h3>Thông tin chuyến bay</h3>
          </div>
          <div>
            {selectedFlights &&
              selectedFlights.length > 0 &&
              selectedFlights.map((flight, idx) => {
                const duration = flight?.thoi_gian_bay || "";
                const logo = flight?.hang_bay?.logo || "";
                let directionTitle = "";
                if (isRoundtrip || selectedFlights.length > 1) {
                  directionTitle = idx === 0 ? "Chiều đi" : "Chiều về";
                }
                return (
                  <div
                    key={idx}
                    style={{
                      marginBottom: 16,
                      width: "100%",
                      border: "1px solid #e0e0e0",
                      borderRadius: 8,
                      padding: 16,
                      background: "#f8fbff",
                      boxShadow: "0 2px 8px rgba(25,118,210,0.04)",
                      position: "relative",
                    }}
                  >
                    {/* Nút thay đổi chiều đi ở góc phải trên */}
                    {(showReturnFlights || selectedFlights.length > 1) &&
                      idx === 0 &&
                      onChangeDeparture && (
                        <button
                          onClick={onChangeDeparture}
                          style={{
                            position: "absolute",
                            top: 12,
                            right: 12,
                            width: 32,
                            height: 32,
                            background: "#007bff",
                            color: "white",
                            border: "none",
                            borderRadius: "50%",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 14,
                            boxShadow: "0 2px 4px rgba(0,123,255,0.3)",
                          }}
                          title="Thay đổi chiều đi"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                      )}

                    {directionTitle && (
                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: 15,
                          color: "#1976d2",
                        }}
                      >
                        {directionTitle}
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 12,
                      }}
                    >
                      {/* Điểm đi */}
                      <div style={{ width: "28%", textAlign: "center" }}>
                        <p
                          style={{
                            margin: 0,
                            color: "#888",
                            fontSize: 13,
                          }}
                        >
                          Điểm đi
                        </p>
                        <h3
                          style={{
                            margin: 0,
                            fontSize: 18,
                            fontWeight: 600,
                          }}
                        >
                          {flight?.diem_di?.tinh}
                        </h3>
                        <p>{flight?.diem_di?.ma}</p>
                      </div>
                      {/* Logo + duration */}
                      <div style={{ width: "34%", textAlign: "center" }}>
                        {logo && (
                          <img
                            src={logo}
                            alt="logo"
                            style={{
                              width: 90,
                              objectFit: "contain",
                              marginBottom: 4,
                            }}
                          />
                        )}
                        <div
                          style={{
                            margin: "6px 0 0 0",
                            fontWeight: 500,
                            fontSize: 14,
                            color: "#333",
                          }}
                        >
                          {flight?.so_hieu}
                        </div>
                        <div
                          style={{
                            fontSize: 13,
                            color: "#1976d2",
                            marginTop: 2,
                          }}
                        >
                          {duration}
                        </div>
                      </div>
                      {/* Điểm đến */}
                      <div style={{ width: "28%", textAlign: "center" }}>
                        <p
                          style={{
                            margin: 0,
                            color: "#888",
                            fontSize: 13,
                          }}
                        >
                          Điểm đến
                        </p>
                        <h3
                          style={{
                            margin: 0,
                            fontSize: 18,
                            fontWeight: 600,
                          }}
                        >
                          {flight?.diem_den?.tinh}
                        </h3>
                        <p>{flight?.diem_den?.ma}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      )}

      {/* Chỉ hiển thị thông tin giá vé khi đã có chuyến được chọn */}
      {selectedFlights && selectedFlights.length > 0 && (
        <div className="left_side_search_boxed">
          <div className="tour_details_right_box_heading">
            <h3>Thông tin giá vé</h3>
          </div>
          <div className="tour_booking_amount_area">
            <ul>
              {/* Hiển thị giá từng chiều, từng loại hành khách */}
              {(() => {
                const flights = selectedFlights;
                const {
                  adults = 1,
                  children = 0,
                  infants = 0,
                } = passengers || {};
                return flights.map((flight, idx) => {
                  const fare = flight?.tuy_chon_gia_ve_mac_dinh;
                  if (!fare) return null;
                  // Tên chiều
                  let directionTitle = "";
                  if (isRoundtrip || flights.length > 1)
                    directionTitle = idx === 0 ? "Chiều đi" : "Chiều về";
                  // Giá từng loại
                  const adt = fare.nguoi_lon?.gia_dai_ly || 0;
                  const adt_fare = fare.nguoi_lon?.gia_fare || 0;
                  const adt_thue = fare.nguoi_lon?.thue + fare.nguoi_lon?.phi_dai_ly || 0;
                  const chd = fare.tre_em?.gia_dai_ly || 0;
                  const chd_fare = fare.tre_em?.gia_fare || 0;
                  const chd_thue = fare.tre_em?.thue + fare.tre_em?.phi_dai_ly || 0;
                  const inf = fare.em_be?.gia_net || 0;
                  const inf_fare = fare.em_be?.gia_fare || 0;
                  const inf_thue = fare.em_be?.thue || 0;
                  // Tổng tiền chiều này
                  const totalChieu =
                    adt * adults + chd * children + inf * infants;
                  return (
                    <React.Fragment key={idx}>
                      <li
                        style={{
                          fontWeight: 700,
                          fontSize: 15,
                          marginTop: idx > 0 ? 8 : 0,
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span>{directionTitle}</span>
                        <span>{totalChieu.toLocaleString()}₫</span>
                      </li>
                      {adults > 0 && (
                        <>
                          <li style={{ fontWeight: 600 }}>
                            Người lớn x {adults}
                          </li>
                          <li
                            style={{
                              fontSize: 13,
                              color: "#666",
                              marginLeft: 10,
                            }}
                          >
                            - Giá vé x {adults}: {(adt_fare * adults).toLocaleString()}₫ |
                            Thuế phí x {adults}: {(adt_thue * adults).toLocaleString()}₫
                          </li>
                        </>
                      )}
                      {children > 0 && (
                        <>
                          <li style={{ fontWeight: 600 }}>
                            Trẻ em x {children}
                          </li>
                          <li
                            style={{
                              fontSize: 13,
                              color: "#666",
                              marginLeft: 10,
                            }}
                          >
                            - Giá vé x {children}: {(chd_fare * children).toLocaleString()}₫
                            | Thuế phí x {children}: {(chd_thue * children).toLocaleString()}
                            ₫
                          </li>
                        </>
                      )}
                      {infants > 0 && (
                        <>
                          <li style={{ fontWeight: 600 }}>Em bé x {infants}</li>
                          <li
                            style={{
                              fontSize: 13,
                              color: "#666",
                              marginLeft: 10,
                            }}
                          >
                            - Giá vé x {infants}: {(inf_fare * infants).toLocaleString()}₫ |
                            Thuế phí x {infants}: {(inf_thue * infants).toLocaleString()}₫
                          </li>
                        </>
                      )}
                    </React.Fragment>
                  );
                });
              })()}
            </ul>
            <div className="tour_bokking_subtotal_area">
              {/* Tổng tiền tất cả các chiều */}
              {(() => {
                const flights = selectedFlights;
                const {
                  adults = 1,
                  children = 0,
                  infants = 0,
                } = passengers || {};
                let total = 0;
                flights.forEach((flight) => {
                  const fare = flight?.tuy_chon_gia_ve_mac_dinh;
                  if (!fare) return;
                  total += (fare.nguoi_lon?.gia_dai_ly || 0) * adults;
                  total += (fare.tre_em?.gia_dai_ly || 0) * children;
                  total += (fare.em_be?.gia_net || 0) * infants;
                });
                return (
                  <h6>
                    Tổng tiền <span>{total.toLocaleString()}₫</span>
                  </h6>
                );
              })()}
            </div>
            {/* Có thể bổ sung code cho coupon hoặc discount nếu cần */}
          </div>
        </div>
      )}

      <div className="left_side_search_boxed">
        <div className="left_side_search_heading">
          <h5>Điểm dừng</h5>
        </div>
        <div className="tour_search_type">
          {Array.from(new Set(stops))
            .sort((a, b) => a - b)
            .map((stop, idx) => (
              <div className="form-check" key={stop + "-" + idx}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  value={stop}
                  id={`stop-${stop}`}
                  checked={checkedStop.includes(stop.toString())}
                  onChange={handleStopChange}
                />
                <label className="form-check-label" htmlFor={`stop-${stop}`}>
                  <span className="area_flex_one">
                    <span>
                      {stop === 1 ? "Bay thẳng" : `${stop - 1} điểm dừng`}
                    </span>
                    <span>{stops.filter((s) => s === stop).length}</span>
                  </span>
                </label>
              </div>
            ))}
        </div>
      </div>
      <div className="left_side_search_boxed">
        <div className="left_side_search_heading">
          <h5>Hãng bay</h5>
        </div>
        <div className="tour_search_type">
          {Array.from(new Set(airlines)).map((airline, idx) => (
            <div className="form-check" key={airline + "-" + idx}>
              <input
                className="form-check-input"
                type="checkbox"
                value={airline}
                id={`airline-${airline}`}
                checked={checkedAirline.includes(airline)}
                onChange={handleAirlineChange}
              />
              <label
                className="form-check-label"
                htmlFor={`airline-${airline}`}
              >
                <span className="area_flex_one">
                  <span>{getName(airline)}</span>
                  <span>{airlines.filter((a) => a === airline).length}</span>
                </span>
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
